module.exports = __webpack_public_path__ + "img/homeBackground.2103001d.png";